module.exports = __webpack_public_path__ + "img/ad.89551548.jpeg";